import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { formatNumber } from '../utils';
import styles from './SentScreen.module.scss';

interface SentScreenProps {
    name: string;
    recipients: number;
    locations: number;
    onDone: () => void;
}

export const SentScreen: React.FC<SentScreenProps> = ({ name, recipients, locations, onDone }) => (
    <div className={styles.root}>
        <span className={styles.icon}>
            <FontAwesomeIcon icon={faPaperPlane} />
        </span>
        <h2>Your campaign is on its way</h2>
        <p>
            <strong>{name}</strong> is sending to {formatNumber(recipients)} customers across {locations} location
            {locations === 1 ? '' : 's'}. Results will show up in Campaigns as emails are opened.
        </p>
        <Button
            variant="black"
            size="large"
            label="Back to campaigns"
            className={styles.button}
            onClick={onDone}
        />
    </div>
);

export default SentScreen;
